import h from 'hyperscript';

import './location-finder-info-panel.css';
import i18n from './location-finder-info-panel.properties';

const COMPONENT_NAME = 'd-location-finder-info-panel';

export class LocationFinderInfoPanel extends HTMLElement {

  constructor (address, attributes) {
    super();
    this.append(
      h('details.d-panel-section.d-location-finder-info-panel--address',
        { open: true },
        h('summary', i18n('infoPanel.address')),
        address
      ),
      h('details.d-panel-section',
        { open: true },
        h('summary', i18n('infoPanel.attributes')),
        createAttributeTable(attributes)
      )
    );
  }

}

function createAttributeTable (attributes) {
  const trs = Object.entries(attributes).map(([ key, value ]) =>
    h('tr',
      h('td.d-location-finder-info-panel--attribute-name', key),
      h('td', value)
    )
  );

  return h('table.d-location-finder-info-panel--attribute-table',
    h('tbody', trs)
  );
}

customElements.define(COMPONENT_NAME, LocationFinderInfoPanel);
